import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout'; // Ensure the path is correct
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ListStudent() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const { subjectId, examId, subjectName, ExamName } = location.state || {};
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [file, setFile] = useState(null); // State for selected file
  const [fileName, setFileName] = useState(''); // State for selected file name
  const [uploading, setUploading] = useState(false); // State for upload statu
  const modalRef = useRef(); // Reference for the modal
  const [invalidRows, setInvalidRows] = useState([]); // State to store invalid rows data
  const [showInvalidRows, setShowInvalidRows] = useState(true);
  const [facultyName, setFacultyName] = useState(''); // State for faculty name
  const [searchTerm, setSearchTerm] = useState('');
  const [setErrorMessage, setInvalidMessage] = useState([]);
  const [students, setStudents] = useState([]); // State to store the student data
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, []);

  // Helper function to generate columns
  const generateColumns = (internalMarks, navigate, handleDelete) => {
    // Extract unique subjects and create dynamic columns
    const subjects = [
      ...new Set(internalMarks.map((record) => record.subjectName)),
    ];
    const dynamicColumns = subjects.map((subject) => ({
      name: subject,
      selector: (row) => row.subjectMarks, // Adjust if you have multiple subjectMarks
      sortable: true,
      width: '150px',
      center: 'true',
    }));

    return [
      {
        name: 'No',
        selector: (row, index) => {
          return (currentPage - 1) * rowsPerPage + index + 1;
        },
        width: '50px',
        center: 'true',
      },
      {
        name: 'Roll Number',
        selector: (row) => row.rollNumber,
        sortable: true,
        width: '150px',
        center: 'true',
      },
      {
        name: 'Name',
        selector: (row) => row.name,
        sortable: true,
      },
      ...dynamicColumns, // Add dynamic subject columns
      {
        name: 'Status',
        selector: (row) => row.status,
        sortable: true,
        width: '100px',
        center: 'true',
        cell: (row) => (
          <span
            style={{
              color: row.status === 'Pass' ? 'green' : 'red',
              fontWeight: 'bold',
            }}
          >
            {row.status}
          </span>
        ),
      },
      {
        name: 'Faculty Name',
        selector: (row) => row.facultyName,
        sortable: true,
        width: '150px',
        center: 'true',
      },
      {
        name: 'Actions',
        width: '115px',
        center: 'true',
        cell: (row) => (
          <div>
            <button
              onClick={() =>
                navigate('/EditInternalMarks', {
                  state: {
                    id: row.id,
                    examId: row.examId,
                    subjectId: row.subjectId,
                  },
                })
              }
              className="btn btn-primary btn-sm mx-2"
              data-tooltip-id="my-tooltip"
              data-tooltip-content="Update Student Marks"
            >
              <i className="bi bi-pencil-square"></i>
            </button>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => handleDelete(row.id)}
              data-tooltip-id="my-tooltip"
              data-tooltip-content="Delete Student Marks"
            >
              <i className="bi bi-trash3-fill"></i>
            </button>
          </div>
        ),
      },
    ];
  };

  // Updated fetchRecords function
  const fetchRecords = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    let data = JSON.stringify({
      examId: examId,
      subjectId: subjectId,
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/internalmarks/list`,
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
      data: data,
    };

    try {
      const response = await axios.request(config);
      const internalMarks = response.data?.internalMarks || [];
      setRecords(internalMarks);
      const totalCount = response.data?.totalinternalMarks || 0;

      // Use the helper function to set columns
      setColumns(generateColumns(internalMarks, navigate, handleDelete));
    } catch (error) {
      console.error('Error fetching records:', error);
      error.response?.status === 401 && navigate('/');
    } finally {
      setLoading(false);
    }
  };

  // search students function with pagination

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this student?')) {
      const token = localStorage.getItem('token');

      try {
        await axios.delete(`${apiUrl}/api/internalmarks/${id}`, {
          headers: {
            Authorization: token,
          },
        });
        setRecords(records.filter((record) => record.id !== id));
        fetchRecords();
        toast.success('Student deleted successfully');
      } catch (error) {
        console.error('Error deleting student:', error);
        error.response?.status === 401 && navigate('/');
        toast.error(error.response.data.message);
      }
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : '');
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('No file selected');
      return;
    }

    if (!facultyName.trim()) {
      toast.error('Faculty name is required');
      return;
    }

    setUploading(true);
    const token = localStorage.getItem('token');

    const formData = new FormData();
    formData.append('examId', examId); // Correct field name for examId
    formData.append('subjectId', subjectId); // Correct field name for subjectId
    formData.append('facultyName', facultyName); // Correct field name for facultyName
    formData.append('internalMarks', file); // Correct field name for the file

    // In handleUpload
    try {
      const response = await axios.post(
        `${apiUrl}/api/internalmarks/upload`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
          maxBodyLength: Infinity,
        }
      );

      toast.success('File uploaded successfully');
      fetchRecords();
      // Hide modal after successful upload
      closemodel();
      // Reset states
      setInvalidRows([]);
      setShowInvalidRows(true);
    } catch (error) {
      if (error.response && error.response.data.invalidRows) {
        setInvalidRows(error.response.data.invalidRows);
        setShowInvalidRows(true);
        setInvalidMessage(error.response.data.message);
        fetchRecords();
        closemodel();
      } else {
        toast.error(error.response?.data?.message);
        fetchRecords();
        closemodel();
        error.response?.status === 401 && navigate('/');
      }
    } finally {
      setUploading(false);
      setFile(null);
      setFileName('');
      setFacultyName('');
      document.getElementById('formFile-question').value = null;
    }
  };
  const invalidRowsColumns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '50px',
      center: 'true',
    },
    {
      name: 'Roll Number',
      selector: (row) => row.rollNumber,
      sortable: true,
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Marks',
      selector: (row) => row.marks,
      sortable: true,
    },
  ];
  const handleDownloadInvalidRows = () => {
    if (invalidRows.length === 0) {
      toast.error('No invalid rows to download');
      return;
    }
    // Convert invalidRows to a format suitable for Excel
    const data = invalidRows.map((row) => ({
      name: row.name,
      rollNumber: row.rollNumber,
      marks: row.marks,
    }));
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert data to worksheet format
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'InvalidRows');

    // Export the Excel file
    XLSX.writeFile(workbook, 'invalid_rows.xlsx');
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = JSON.stringify({
        examId: examId,
        subjectId: subjectId,
      });
      const token = localStorage.getItem('token');
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/students/list`,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        data: data,
      };

      try {
        const response = await axios.request(config);

        // Store the student data in the state
        setStudents(response.data.students);
      } catch (error) {
        console.log(error); // Handle error
      }
    };

    fetchData();
  }, []);

  const handleDownload = () => {
    // Prepare the data for the Excel sheet
    const data = [
      ['rollNumber', 'name', 'marks'], // Header row
      ...students.map((student) => [student.rollNumber, student.name, '']),
    ];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert data to worksheet format
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'StudentMarks');

    // Export the Excel file
    XLSX.writeFile(
      workbook,
      `${ExamName} of ${subjectName} Internal marks.xlsx`
    );
  };

  const handleHideTable = () => {
    setShowInvalidRows(false);
    setInvalidRows([]); // Clear the invalid rows only when hiding the table
  };

  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac7="active">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-2)}>
                    Exams for Internal Marks
                  </span>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-1)}>
                    Subject list
                  </span>
                </li>
                <li className="breadcrumb-item active">
                  Internal Marks for ({subjectName})
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          {showInvalidRows && invalidRows.length > 0 && (
            <div className="card">
              <div className="card-body" style={{ backgroundColor: '#f0b7b7' }}>
                <div className=" mt-2 mb-2">
                  <div class="d-flex justify-content-between ">
                    <div class="bd-highlight ms-5"></div>
                    <div class="bd-highlight ms-4 mt-2 ps-5">
                      <strong>{setErrorMessage}</strong>
                    </div>
                    <div class=" bd-highlight">
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={handleDownloadInvalidRows}
                      >
                        <i className="bi bi-file-earmark-excel"></i> Export to
                        Excel
                      </button>
                      <button
                        className="btn btn-secondary ms-2 btn-sm"
                        onClick={handleHideTable}
                      >
                        <i className="bi bi-x-circle"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={invalidRowsColumns}
                    data={invalidRows}
                    className="custom-table"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="container ">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search"
                    title="Search within table"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary mx-2"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Upload Marks"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <i className="bi bi-file-earmark-arrow-up"></i> Upload
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary "
                    onClick={() =>
                      navigate('/AddInternalmarks', {
                        state: {
                          subjectId: subjectId,
                          examId: examId,
                          subjectName: subjectName,
                        },
                      })
                    }
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Add marks"
                  >
                    <i className="bi bi-plus-square"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records.filter((record) => {
                    const nameMatches = record.name
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase());
                    const rollNumberMatches = record.rollNumber
                      .toString() // Convert rollNumber to string
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase());

                    return nameMatches || rollNumberMatches;
                  })}
                  progressPending={loading}
                  pagination
                  className="custom-table"
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
          <Tooltip id="my-tooltip" />
        </AdminLayout>
      </main>
      {/* Modal for File Upload */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-ms">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <h5
                className="modal-title text-white p-1 rounded"
                id="exampleModalLabel"
              >
                {ExamName} of {subjectName}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col  text-center">
                <label className="mb-2">Upload Student Internal Marks</label>
                <div
                  className="upload-area"
                  onClick={() =>
                    document.getElementById('formFile-question').click()
                  }
                  style={{ cursor: 'pointer', width: '465px' }}
                >
                  <div className="icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                      alt="Upload"
                    />
                  </div>
                  <p className="text">Click to upload Student Details</p>
                  <input
                    className="form-control"
                    name="questionpaper"
                    type="file"
                    id="formFile-question"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    accept=".xlsx"
                  />
                  {fileName && (
                    <div className="mt-2">
                      <strong>{fileName}</strong>
                    </div>
                  )}
                </div>
              </div>
              {/* Faculty Name Input */}
              <div className="form-group mt-3">
                <input
                  type="text"
                  className="form-control"
                  id="facultyNameInput"
                  placeholder="Enter Faculty Name"
                  value={facultyName}
                  onChange={(e) => setFacultyName(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary mx-1"
                onClick={handleDownload}
              >
                Download Example
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpload}
                disabled={uploading}
              >
                {uploading ? 'Uploading...' : 'Upload'}
              </button>
              <button
                type="button"
                className="btn btn-secondary mx-1"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
